import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Monitor,
  ChefHat,
  Wine,
  Settings,
  ShoppingBag,
  Users,
  Activity,
  Database,
  Shield,
} from "lucide-react";

const Navigation = () => {
  const location = useLocation();

  const navItems = [
    { path: "/caisse", name: "Caisse", icon: Monitor, color: "#FFB800" },
    { path: "/cuisine", name: "Cuisine", icon: ChefHat, color: "#FF4757" },
    { path: "/bar", name: "Bar", icon: Wine, color: "#3B82F6" },
    {
      path: "/admin",
      name: "Admin",
      icon: Shield,
      color: "#8B5CF6",
      role: "admin",
    },
    {
      path: "/manager",
      name: "Manager",
      icon: Activity,
      color: "#38A169",
      role: "manager",
    },
    {
      path: "/stock",
      name: "Stock",
      icon: Database,
      color: "#805AD5",
      role: "manager",
    },
    {
      path: "/clients",
      name: "Clients",
      icon: Users,
      color: "#ED64A6",
      role: "manager",
    },
    {
      path: "/commandes",
      name: "Commandes",
      icon: ShoppingBag,
      color: "#F6AD55",
      role: "manager",
    },
  ];

  // Filtre les éléments de navigation en fonction du rôle de l'utilisateur
  const userRole = localStorage.getItem("userRole") || "admin"; // Mode admin par défaut pour le développement
  const filteredNavItems = navItems.filter(
    (item) => !item.role || item.role === userRole,
  );

  return null;
};

export default Navigation;
